export default {
  GET_FINANCIAL_TRANSACTION_LOADING: 'GET_FINANCIAL_TRANSACTION_LOADING',
  GET_FINANCIAL_TRANSACTION_SUCCESS: 'GET_FINANCIAL_TRANSACTION_SUCCESS',
  GET_FINANCIAL_TRANSACTION_FAILED: 'GET_FINANCIAL_TRANSACTION_FAILED',
  GET_FINANCIAL_TRANSACTION_REJECT: 'GET_FINANCIAL_TRANSACTION_REJECT',

  GET_FINANCIAL_TRANSACTION_TYPES_LOADING: 'GET_FINANCIAL_TRANSACTION_TYPES_LOADING',
  GET_FINANCIAL_TRANSACTION_TYPES_SUCCESS: 'GET_FINANCIAL_TRANSACTION_TYPES_SUCCESS',
  GET_FINANCIAL_TRANSACTION_TYPES_FAILED: 'GET_FINANCIAL_TRANSACTION_TYPES_FAILED',
  GET_FINANCIAL_TRANSACTION_TYPES_REJECT: 'GET_FINANCIAL_TRANSACTION_TYPES_REJECT',
};